/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * Avatar CSS
 */
export const styles = css`
  :host {
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .text__avatar {
    box-sizing: border-box;
    font-family: var(--nile-font-family-serif , var(--ng-font-family-body));
    font-style: normal;
    aspect-ratio: 1 / 1;
    font-weight: var(--nile-font-weight-semi-bold , var(--ng-font-weight-semibold));
    color: var(--nile-colors-white-base , var(--ng-colors-text-quaternary-500));
    border-radius: var(--nile-radius-radius-xs , var(--ng-radius-xs));
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }

  .avatar {
    box-sizing: border-box;
    border: 0.5px solid var(--nile-colors-neutral-500 , var(--ng-colors-border-secondary));
    border-radius: var(--nile-radius-radius-xs , var(--ng-radius-xs));
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
  }

  .avatar__xs {
    width: var(--nile-type-scale-4, var(--ng-height-24px));
    height: var(--nile-type-scale-4), var(--ng-height-24px);
    font-size: var(--nile-font-size-6-7, var(--ng-font-size-text-xs));
    line-height: var(--nile-font-size-6-7, var(--ng-line-height-text-xs));
  }
  
  .avatar__small {
    width: var(--nile-type-scale-4, var(--ng-height-32px));
    height: var(--nile-type-scale-4, var(--ng-height-32px));
    font-size: var(--nile-font-size-6-7, var(--ng-font-size-text-sm));
    line-height: var(--nile-font-size-6-7, var(--ng-line-height-text-sm));
  }

  .avatar__medium {
    width: var(--nile-spacing-3-x, var(--ng-height-40px));
    height: var(--nile-spacing-3-x, var(--ng-height-40px));
    font-size: var(--nile-spacing-2-x, var(--ng-font-size-text-md));
    line-height: var(--nile-type-scale-5, var(--ng-line-height-text-md));
  }

  .avatar__large {
    width: var(--nile-spacing-4xl, var(--ng-height-48px));
    height: var(--nile-spacing-4xl, var(--ng-height-48px));
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-lg));
    line-height: var(--nile-type-scale-6, var(--ng-line-height-text-lg));
  }

  .avatar__extralarge {
    height: var(--nile-spacing-5xl, 56px);
    width: var(--nile-spacing-5xl, 56px);
    font-size: var(--nile-spacing-xl, var(--ng-font-size-text-xl));
    line-height: var(--nile-spacing-3xl , var(--ng-line-height-text-xl));
  }

  .avatar__2xl {
    height: var(--nile-spacing-spacing-7xl, var(--ng-spacing-7xl));
    width: var(--nile-spacing-spacing-7xl, var(--ng-spacing-7xl));
    font-size: var(--nile-spacing-3xl, var(--ng-line-height-display-xs));
    line-height: var(--nile-spacing-4xl, var(--ng-line-height-display-xs));
  }

  .avatar__rounded {
    border-radius: 50%;
  }

  .variant__orange {
    background:var(--nile-avatar-background-color-orange , var(--ng-colors-bg-tertiary));
  }

  .variant__pink {
    background: var(--nile-avatar-background-color-pink, var(--ng-colors-bg-tertiary));
  }

  .variant__blue {
    background: var(--nile-avatar-background-color-blue, var(--ng-colors-bg-tertiary));
  }

  .variant__light_blue {
    background: var(--nile-avatar-background-color-lightblue , var(--ng-colors-bg-tertiary));
  }

  .variant__green {
    background: var(--nile-avatar-background-color-green, var(--ng-colors-bg-tertiary));
  }
`;

export default [styles];
